import Tippy from '@tippyjs/react';
import { RenderElementProps } from 'slate-react';
import { MentionElement } from 'slate/types/slate';
import { useReferenceDataByRevisionId, useReferenceList } from 'entities/reference-data';
import { useEditorDocument, useEditorLocale } from 'app/api/documents/useEditorData';
import { localizedCellValue } from 'app/utils/table';

const LOADING = 'Loading..';
const MISSING_CELL = '???';

export const Mention = ({ attributes, children, element }: RenderElementProps) => {
  const { data: document } = useEditorDocument();
  const locale = useEditorLocale();
  const { data: references = [], isLoading: isReferenceListLoading } = useReferenceList(document, { keepPreviousList: true });
  const data = (element as MentionElement).data as { referenceId: string; selection: [number, number] };
  const { data: referenceData, isLoading: isReferenceLoading } = useReferenceDataByRevisionId(data.referenceId);

  const [row, column] = data.selection;
  const reference = references.find((item) => item.superId === referenceData?.superId);
  const cell = reference?.selectionContent?.[row]?.[column];
  const referenceLocale = document?.content?.referenceData?.find((entry) => entry.superId === referenceData?.superId)?.locale;
  const value = cell && localizedCellValue(cell, locale, referenceLocale === locale);

  const output = isReferenceListLoading || isReferenceLoading ? LOADING : value || MISSING_CELL;
  const referenceString = reference ? `(${reference.name} - ${data.selection})` : MISSING_CELL;
  return (
    <Tippy content={<p className="gaby-tooltip">{referenceString}</p>} placement="top">
      <span {...attributes} className="reference">
        <span style={{ userSelect: 'none' }} contentEditable={false}>
          {output}
          {children}
        </span>
      </span>
    </Tippy>
  );
};
